import React from 'react';
import { Star, ExternalLink, BadgeCheck } from 'lucide-react';

const reviews = [
  {
    initials: 'RK',
    name: 'Rajesh Kumar',
    role: 'Working Professional — Bhopal',
    color: 'bg-blue-500',
    text: 'Best decision I made for my trading journey. The practical approach and risk management techniques taught by Deepak Singhai have completely transformed how I trade. Small batch means real personal attention.',
  },
  {
    initials: 'PS',
    name: 'Priya Sharma',
    role: 'Beginner Trader — Bhopal',
    color: 'bg-red-500',
    text: 'Started with zero knowledge. The way Deepak Singhai explains complex concepts in simple language made everything easy. Live market sessions are what make this academy truly different. Highly recommended!',
  },
  {
    initials: 'AP',
    name: 'Amit Patel',
    role: 'Business Owner — Bhopal',
    color: 'bg-green-500',
    text: 'Excellent course structure. The options trading module helped me understand derivatives clearly. Post-course support is a huge plus — Deepak Singhai is always available to guide you even after the batch ends.',
  },
];

const GOOGLE_REVIEW_URL = 'https://share.google/ZjOtMuHoZvlxEPeZT';

const GoogleReviews = () => {
  return (
    <section className="bg-zinc-50 py-16 sm:py-20" id="testimonials" data-testid="google-reviews-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3">
            Google Reviews
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-3">
            What Students Say on <span className="text-green-600">Google</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Real reviews from real students — verified on Google Business Profile for Stocks Vision Academy, Bhopal.
          </p>
        </div>

        {/* Top Score Card */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-7 mb-6 flex flex-wrap items-center gap-6">
          <div className="text-center flex-shrink-0">
            <div className="text-5xl font-extrabold text-gray-900 leading-none">4.9</div>
            <div className="flex justify-center my-1.5">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-xs text-gray-500">500+ Student Reviews</span>
          </div>
          <div className="hidden sm:block w-px h-16 bg-gray-200" />
          <div className="flex-1 min-w-[200px]">
            <p className="text-sm sm:text-base text-gray-800 font-medium mb-2">
              Rated 4.9/5 by students of Stocks Vision Academy, Bhopal on Google Business Profile
            </p>
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors"
              data-testid="google-reviews-cta"
            >
              <Star className="h-4 w-4 fill-white" /> View All Google Reviews <ExternalLink className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {reviews.map((r) => (
            <div key={r.name} className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-6" data-testid={`google-review-card-${r.name.replace(/\s+/g, '-').toLowerCase()}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 ${r.color} rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0`}>
                  {r.initials}
                </div>
                <div className="flex-1 min-w-0">
                  <strong className="block text-sm font-bold text-gray-900 truncate">{r.name}</strong>
                  <span className="text-xs text-gray-500">{r.role}</span>
                </div>
                <div className="flex">
                  {[0, 1, 2, 3, 4].map((j) => (
                    <Star key={j} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
                  ))}
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
              <div className="flex items-center gap-1.5 mt-3 text-xs text-gray-500">
                <BadgeCheck className="h-3.5 w-3.5 text-green-600" />
                <span>Posted on Google</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
